/**
 * Case-insensitive substring search across a set of fields.
 * Pure and framework-free — usable from a handler, a test, or a future worker.
 */
export function search<T>(items: T[], query: string, fields: Array<(item: T) => unknown>): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return items;
  return items.filter((item) =>
    fields.some((field) => {
      const value = field(item);
      if (Array.isArray(value)) {
        return value.some((v) => String(v).toLowerCase().includes(q));
      }
      return String(value ?? "").toLowerCase().includes(q);
    }),
  );
}
